import { createFileRoute } from '@tanstack/react-router';
import DepotEdit from '~/containers/DepotEdit';

export const Route = createFileRoute('/depots/$depotId')({
  component: DepotEdit,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
